import { $vfm } from 'vue-final-modal';

export function openPopup(errorMessage, fn) {
    $vfm.show({
        component: 'DialogBase',
        params: {
            title: '系統提示',
            content: errorMessage || '系統忙碌中，請稍後再試',
            confirmButton: '確認',
            cancelButton: null,
            closeicon: true,
        },
        on: {
            confirm() {
                $vfm.hide('DialogBase');
                if (fn) {
                    fn();
                }
            },
            closed() {
                $vfm.hide('DialogBase');
                if (fn) {
                    fn();
                }
            },
        },
    });
};

export function openPopupCatchMessage(err) {
    if (err.data?.details && err.data?.details?.length > 0) {
        openPopup((err?.data?.errorMessage ? err.data.errorMessage + '<br>' : '') + joinErrorDetails(err));
    } else {
        openPopup(err?.data?.errorMessage);
    }
};

export function joinErrorDetails(err) {
    return err.data.details.map(e => {
        return e.field ? `${e.field}: ${e.errorMessage}` : e.errorMessage;
    }).join('<br>');
};
